module.exports = __webpack_public_path__ + "img/112.b67c0497.jpg";